export default () => {
  if (document.readyState != 'loading') return Promise.resolve();
  return new Promise((f, r) => {
    document.addEventListener('DOMContentLoaded', f);
  });
};
